import { Button, Form } from "react-bootstrap";
import { CarManageFormPartModel } from "./carManageFormPartModel";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { z } from "zod";
import { useAuthorization } from "../../../../../hooks/useAuthorization";
import { CarEventsModal } from "../carEventsModal/CarEventsModal";

export const CarManageFormPart = ({
  form,
  onSubmit,
  onDelete,
}: CarManageFormPartModel) => {
  const { t } = useTranslation("common");
  const { id } = useParams();
  const { hasRole } = useAuthorization();

  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        e.stopPropagation();
        void form.handleSubmit();
      }}
    >
      {/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */}
      {/* @ts-ignore*/}
      <form.Field key="is_lease" name="is_lease">
        {(field) => {
          return (
            <Form.Group>
              <Form.Check
                id={field.name}
                key={field.name}
                name={field.name}
                checked={field.state.value}
                onBlur={field.handleBlur}
                onChange={(e) => {
                  field.handleChange(e.target.checked);
                }}
                label={t("Lease car")}
              />
            </Form.Group>
          );
        }}
      </form.Field>
      <form.Field key="freestock_tire" name="freestock_tire">
        {(field) => {
          return (
            <Form.Group>
              <Form.Check
                id={field.name}
                key={field.name}
                name={field.name}
                checked={field.state.value}
                onBlur={field.handleBlur}
                onChange={(e) => {
                  field.handleChange(e.target.checked);
                }}
                label={t("Free stock")}
                readOnly={!(hasRole("dbh-manager") || hasRole("super-admin"))}
                disabled={!(hasRole("dbh-manager") || hasRole("super-admin"))}
              />
            </Form.Group>
          );
        }}
      </form.Field>
      <form.Field key="status" name="status">
        {(field) => {
          return (
            <Form.Group>
              <Form.Check
                id={field.name}
                key={field.name}
                name={field.name}
                checked={field.state.value}
                onBlur={field.handleBlur}
                onChange={(e) => {
                  field.handleChange(e.target.checked);
                }}
                label={t("Active")}
                className="mb-3"
              />
            </Form.Group>
          );
        }}
      </form.Field>

      {!hasRole("dealer-employee") && (
        <form.Field
          name="comment"
          key="comment"
          validators={{
            onChange: z.string().optional().nullable(),
          }}
        >
          {(field) => {
            return (
              <Form.Group className="mb-3">
                <Form.Label>{t("Comment")}</Form.Label>
                <Form.Control
                  as="textarea"
                  id={field.name}
                  key={field.name}
                  name={field.name}
                  value={field.state.value || ""}
                  placeholder={!field.state.value ? t("Comment") : undefined}
                  onChange={(e) => field.handleChange(e.target.value)}
                />
              </Form.Group>
            );
          }}
        </form.Field>
      )}

      {!hasRole("dbh-employee") &&
        !hasRole("dbh-driver") &&
        !hasRole("dbh-order-picker") && (
          <div className={"d-flex justify-content-between"}>
            <div className={"d-flex"}>
              <div className={"me-3"}>
                <Button onClick={() => onSubmit()}>{t(`Submit`)}</Button>
              </div>
              <div>
                {!hasRole("dealer-employee") && id && (
                  <Button className={"btn-light"} onClick={() => onDelete()}>
                    {t(`Delete`)}
                  </Button>
                )}
              </div>
            </div>

            <div>
              {(hasRole("super-admin") || hasRole("dbh-manager")) && (
                <>
                  {form.state.values.licencePlate && (
                    <CarEventsModal
                      carLicence={form.state.values.licencePlate}
                    />
                  )}
                </>
              )}
            </div>
          </div>
        )}
    </form>
  );
};
